import { render, staticRenderFns } from "./cadastro_novo_atendente.vue?vue&type=template&id=71826e8e&scoped=true"
import script from "./cadastro_novo_atendente.vue?vue&type=script&lang=js"
export * from "./cadastro_novo_atendente.vue?vue&type=script&lang=js"
import style0 from "./cadastro_novo_atendente.vue?vue&type=style&index=0&id=71826e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71826e8e",
  null
  
)

export default component.exports